export default "__VITE_PUBLIC_ASSET__c3484dfe__"